import React from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { editQuestionnaire } from 'Consts/Questionnaire';
import FinancialWellness from 'Components/ClientApp/CombinedApp/Viewport/Dashboard/LegacyFinancialWellness';
import Goals from 'Components/ClientApp/CombinedApp/Viewport/Dashboard/GoalsAndObjectives/GoalsBlueprint';
import ShadowBox from 'Components/UI/ShadowBox';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import Content from '../UI/Content';
import '../UI/FinancialSummary/index.css';

const FamilyInfo = ({
  financialGoals,
  isAgent,
}) => {
  const simpleHousehold = useSimpleHousehold();
  function getEditLink(page, section) {
    if (simpleHousehold.householdResource) {
      return editQuestionnaire(page, {
        section,
        isAgent,
        householdId: simpleHousehold.householdResource.id(),
      });
    }
    return null;
  }

  return (
    <Content>
      <div className="blueprint-family-info-container">
        <ShadowBox className="blueprint-goals-objectives">
          <h4 className="bordered">
            Goals &amp; Objectives
            {getEditLink('goals', '') && (<EditButtonLink
              title="Edit Goals"
              to={getEditLink('goals', '')}
            />)}
          </h4>
          <Goals
            financialGoals={financialGoals}
            isAgent={isAgent}
          />
        </ShadowBox>
        <ShadowBox className="blueprint-financial-wellness">
          <h4 className="bordered">Financial Wellness</h4>
          <FinancialWellness />
        </ShadowBox>
      </div>
    </Content>
  );
};

FamilyInfo.propTypes = {
  financialGoals: PropTypes.array.isRequired,
  isAgent: PropTypes.bool,
};

FamilyInfo.defaultProps = {
  isAgent: false,
};

export default FamilyInfo;
